// extracted by mini-css-extract-plugin
export default {"feature-action-button":"FeatureActionButton_feature-action-button__91fnF","button-label":"FeatureActionButton_button-label__-al8H"};